import { Component, OnInit, OnChanges, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'app-file-upload-field',
    templateUrl: './file-upload-field.component.html',
    styles: [],
    providers: [MatSnackBar]
})
export class FileUploadFieldComponent implements OnInit, OnChanges {
    @Input() file: File;
    @Input() dropzoneLabel: string;

    @Output() fileChange: EventEmitter<File> = new EventEmitter(false);

    constructor(
        private cdr: ChangeDetectorRef,
        private snackBar: MatSnackBar) {
    }

    ngOnInit(): void {

    }

    ngOnChanges(): void {
        this.cdr.detectChanges();
    }

    onSelect(event) {
        if (event.addedFiles.length > 0) {
            this.file = event.addedFiles[0];
            this.fileChange.emit(this.file);
        } else {
            this.snackBar.open(`Cannot upload file. File must be less than 25 MB.
                File must be of the one of the following types: (.doc, .docx, .jpeg, .jpg, .png, .pdf)`, 'OK', {
                duration: 8000
            });
        }
        this.file = null;
    }

    onRemove() {
        this.file = null;
        this.fileChange.emit(this.file);
    }

    isImage(): boolean {
        return this.file && this.file.type.includes('image');
    }
}
